export default __webpack_public_path__ + "static/media/m_highway.707b436c.png";